module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"test":{"title":"Total amount of risks over time.","xAxis_label":"Month","yAxis_label":"Risk"}},"nl":{"test":{"title":"Aantal risico\u0027s over tijd.","xAxis_label":"Maand","yAxis_label":"Risico"}}}')
  delete Component.options._Ctor
}
